import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNext = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "m25.411 38.413-2.121-2.121L35.583 24 23.29 11.707l2.121-2.121L39.825 24z" }), /* @__PURE__ */ _jsx("path", { d: "m14.26 38.413-2.121-2.121L24.432 24 12.139 11.707l2.121-2.121L28.674 24z" })] }) })
});
export default SvgNext;
